import useAuthentication from '../../hooks/useAuthentication.js';
import eAssistLogo from '../../assets/eAssist-icon.png';
import '../styles/ExecutivePortalChrome.css';

/**
 * Minimal top bar for the Executive Pulse entry portal (no Oracle app navigation).
 */
export default function ExecutivePortalChrome() {
    const { logout, loading } = useAuthentication();

    const handleSignOut = async () => {
        await logout({ returnTo: '/executive-pulse' });
    };

    return (
        <header className="executive-portal-chrome">
            <div className="executive-portal-chrome__brand">
                <img src={eAssistLogo} alt="" width={28} height={28} />
                <span className="executive-portal-chrome__title">
                    Executive Pulse
                </span>
            </div>
            <button
                type="button"
                className="executive-portal-chrome__signout"
                disabled={loading}
                onClick={handleSignOut}>
                Sign out
            </button>
        </header>
    );
}
